import { useMemo } from 'react'
import { Modifier } from 'react-popper'
import { PopoverModifier } from 'types/ui'

interface PopperModifiersSettings {
  flip: boolean
  arrow: boolean
  offset: [number, number]
  arrowElement?: HTMLDivElement | null
}

export function usePopperModifiers({
  flip,
  offset,
  arrow,
  arrowElement,
}: PopperModifiersSettings) {
  // popperjs/core modification options
  return useMemo(() => {
    const modificationList: Modifier<PopoverModifier, object>[] = [
      // remove event listeners on scroll and resize which call the update function.
      // calling update manually on visibility change to save renders.
      { name: 'eventListeners', options: { scroll: false, resize: false } },
      { name: 'offset', options: { offset } },
    ]
    if (flip) {
      modificationList.push({
        name: 'flip',
        options: {
          allowedAutoPlacements: ['top', 'bottom', 'left', 'right'],
        },
      })
    }
    if (arrow) {
      modificationList.push({
        name: 'arrow',
        options: { element: arrowElement },
      })
    }

    return modificationList
  }, [arrow, arrowElement, flip, offset])
}
